import Vue from "vue";
import PaginatedService from "./paginated.service";

class InvoicesService extends PaginatedService {
  static get resource() {
    return "admin/invoices/";
  }
}

export default InvoicesService;
